import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFunction } from "pro-features/components/WithTrack/src/WithTrack";

const SI_PLAYBOOKS_CATEGORY = "SI playbooks";

const createPlaybooksTrackingService = (track: TrackFunction) => {
    const trackPlaybooksEvent = (action: string, eventName: string): void => {
        track(SI_PLAYBOOKS_CATEGORY, action, eventName);
    };

    return {
        trackNewPlaybook() {
            trackPlaybooksEvent("click", "new playbook");
        },
        trackEditPlaybook(isShared: boolean) {
            trackPlaybooksEvent("click", createTrackingEventName("edit playbook", isShared ? "shared" : "private"));
        },
        trackDeletePlaybookConfirm() {
            trackPlaybooksEvent("click", createTrackingEventName("delete playbook", "confirm"));
        },
        trackBulkDelete(count: number) {
            trackPlaybooksEvent("click", createTrackingEventName("delete selected", count));
        },
        trackSegmentChange(segment: string) {
            trackPlaybooksEvent("click", createTrackingEventName("segment", segment));
        },
        trackListRetry() {
            trackPlaybooksEvent("click", createTrackingEventName("retry", "list"));
        },
        trackLegendStepClick(stepName: string) {
            trackPlaybooksEvent("click", createTrackingEventName("step navigation", stepName));
        },
        trackNext(stepName: string) {
            trackPlaybooksEvent("click", createTrackingEventName("next", stepName));
        },
        trackBack(stepName: string) {
            trackPlaybooksEvent("click", createTrackingEventName("back", stepName));
        },
        trackCancel() {
            trackPlaybooksEvent("click", "cancel");
        },
        trackSubmit(mode: "create" | "save") {
            trackPlaybooksEvent("click", mode);
        },
        trackUnsavedLeave() {
            trackPlaybooksEvent("click", createTrackingEventName("unsaved changes", "leave"));
        },
        trackUnsavedStay() {
            trackPlaybooksEvent("click", createTrackingEventName("unsaved changes", "stay"));
        },
        trackVisibilityChange(isShared: boolean) {
            trackPlaybooksEvent("click", createTrackingEventName("visibility", isShared ? "shared" : "private"));
        },
        trackToggleProfile(enabled: boolean) {
            trackPlaybooksEvent("click", createTrackingEventName("profile toggle", enabled ? "on" : "off"));
        },
        trackCreateProfile() {
            trackPlaybooksEvent("click", "create profile");
        },
        trackEditProfile() {
            trackPlaybooksEvent("click", "edit profile");
        },
        trackDeleteProfileOpen() {
            trackPlaybooksEvent("click", createTrackingEventName("delete profile", "open"));
        },
        trackDeleteProfileConfirm() {
            trackPlaybooksEvent("click", createTrackingEventName("delete profile", "confirm"));
        },
        trackDeleteProfileCancel() {
            trackPlaybooksEvent("click", createTrackingEventName("delete profile", "cancel"));
        },
        trackProfileSubmit(mode: "create" | "edit") {
            trackPlaybooksEvent("click", createTrackingEventName("profile submit", mode));
        },
        trackProfileDeleteFromModalOpen() {
            trackPlaybooksEvent("click", createTrackingEventName("profile delete from modal", "open"));
        },
        trackContactsLimitChange() {
            trackPlaybooksEvent("click", "contacts limit change");
        },
        trackContactsLimitClear() {
            trackPlaybooksEvent("click", "contacts limit clear");
        },
        trackEmployeeLocationChange() {
            trackPlaybooksEvent("click", "employee location change");
        },
        trackEmployeeLocationClear() {
            trackPlaybooksEvent("click", "employee location clear");
        },
        trackSelectCadence() {
            trackPlaybooksEvent("click", "select cadence");
        },
        trackSalesloftReconnect() {
            trackPlaybooksEvent("click", "salesloft reconnect");
        },
        trackCadenceRetry() {
            trackPlaybooksEvent("click", createTrackingEventName("cadence", "retry"));
        },
    };
};

export default createPlaybooksTrackingService;
